// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__37xVO","content":"ManualTimeModal_content__2c3PK"};